module.exports = __webpack_public_path__ + "img/super-spruce-badge.947148a9.png";